import { memo } from 'react'
import { ChatType } from '../constants'
import { usePresenceStatus } from '../hooks/usePresenceStatus'
import { useAppSelector } from '../redux/hooks'
import { User } from '../types/api'
import { presenceDotClass } from '../utils/presence'
import ChatAvatar from './image/ChatAvatar'

const UserItem = memo(
  ({
    chat,
    onSelect,
    hideDot,
  }: {
    chat: User
    isActive?: boolean
    onSelect?: () => void
    onPin?: (e: any) => void
    last_active?: string
    hideDot?: boolean
  }) => {
    const status = presenceDotClass(usePresenceStatus(chat?.id))
    const { user } = useAppSelector((store) => store.auth)

    const isMe = user?.chat_id == chat.id
    return (
      <div className="chat-item" onClick={onSelect}>
        <div className="custom-avatar-img avatar-container">
          <div className="custom-avatar-img-container">
            <div className={`profile ${hideDot ? '' : status}`}>
              <ChatAvatar data={chat} name={chat} customClass="avtar-sm" />
            </div>
            {chat.onlineStatus !== ChatType.group && user?.id != chat.id && !hideDot && (
              <span className={`status-dot ${status}`} />
            )}
          </div>
            <div className="chat-name">{`${chat.name} ${isMe ? '(ME)' : ''}`}</div>
        </div>
      </div>
    )
  },
)

export default UserItem
